module.exports = __webpack_public_path__ + "img/copy.3179a111.svg";